import {
    Typography,
    Grid,
    Button,
    Box,
    TextField,
    Fade,
    IconButton,
    InputAdornment,
    CircularProgress,
    alpha,
    Alert,
    Snackbar,
    createTheme,
    Dialog,
  } from "@mui/material";
  import { useContext, useEffect, useState } from "react";
  import { useNavigate } from "react-router-dom";
  import {
    Visibility,
    VisibilityOff,
    Login as LoginIcon,
  } from "@mui/icons-material";
import CreateAccountModel from "../../models/CreateAccountModel";
import api from "../../app/api/agent"
import axios from "axios";
import { GlobalStateContext } from "../../store/GlobalState";
import CreateAccountValid from "../../function/CreateAccountValid";
  
  const LoginPage = () => {
    //const theme = useTheme();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const [errorGeneral, setErrorGeneral] = useState<boolean | null>(null);
    const [errorPassword, setErrorPassword] = useState<boolean | null>(null);
    const [errorConfirmPassword, setErrorConfirmPassword] = useState<string | null>(null);
    const [errorEmail, setErrorEmail] = useState<boolean | null>(null);
    const [errorCompany, setErrorCompany] = useState<boolean | null>(null);
    const [errorPhoneNumber, setErrorPhoneNumber] = useState<boolean | null>(null);
    const [errorhelperText, setErrorHelperText] = useState<string | null>(null);
    const navigate = useNavigate();
  

    const [CreateAccountData, setCreateAccount] = useState(new CreateAccountModel())
    const [showPasswordCreate, setShowPasswordCreate] = useState(false);
    const [showPasswordDoubleCreate, setShowPasswordDoubleCreate] = useState(false);
    const [isLoadingCreate, setIsLoadingCreate] = useState(false);
    const [isLoadingForgotPassword, setIsLoadingForgotPassword] = useState(false);
    const [confirmPassword, setConfirmPassword] = useState<string | undefined>(undefined);

    const [isHovered, setIsHovered] = useState(false);
    const [isHoveredPasswordApply, setIsHoveredPasswordApply] = useState(false);
    const [isHoveredConfirmPassword, setIsHoveredConfirmPassword] = useState(false);

    const [errorForgotPassword, setErrorForgotPassword] = useState<string | null>(null);
    const [errorForgotPasswordEmail, setErrorForgotPasswordEmail] = useState<boolean | null>(null);
    const [forgotPasswordEmail, setForgotPasswordEmail] = useState("");


    const EnterKeyOnClick = (event: React.KeyboardEvent) => {
      if (event.key === "Enter") {
        handleLoginOnclick();
      }
    };
    
    const EnterKeyOnClickCreate = (event: React.KeyboardEvent) => {
      if (event.key === "Enter") {
        handleCreate();
      }
    };

    const EnterKeyOnClickSendForgotPasswordEmail = (event: React.KeyboardEvent) => {
      if (event.key === "Enter") {
        handleSendForgotPasswordEmail();
      }
    };

    const handleSendForgotPasswordEmail = async () => {
  
      try {
        await setIsLoadingForgotPassword(true);
        setErrorForgotPassword(null);
        setErrorForgotPasswordEmail(null)
        
        var errorMsg = "";

        if (!forgotPasswordEmail) {
          errorMsg = "Please enter email.\n 請輸入電子郵件。 \n";
        }

        if(errorMsg !== ""){
          setErrorForgotPassword(errorMsg)
          if(errorMsg.includes("email")){
            setErrorForgotPasswordEmail(true)
          }
          setIsLoadingForgotPassword(false);
        }
        else{
          axios.post(`${process.env.REACT_APP_BASE_URL}/api/Account/password/forget`, {email: forgotPasswordEmail}).then((response)=>{
                  if (response.status !== 200){
                      setErrorForgotPassword(response.data);
                      setErrorForgotPasswordEmail(true)
                      setIsLoadingForgotPassword(false);
                  }else{
                    setOpenForgotPasswordEmailSuccess(true);
                    setOpenForgotPassword(false);
                    setIsLoadingForgotPassword(false);
                  }
              }).catch((ex: any)=>{
                  setErrorForgotPassword(ex.response.data);
                  setErrorForgotPasswordEmail(true)
                  setIsLoadingForgotPassword(false);
              })
          
        }
      } catch (ex: any) {
        setError(
          ex.data?.message || "Send Forgot Password Email failed. \n 發送忘記密碼電子郵件失敗 \n"
        );
        setErrorForgotPasswordEmail(true)
        setIsLoadingForgotPassword(false);
      }
    };

    const handleCreate = async () => {
    //   if (!email || !password) {
    //     setError("Please enter both email and password");
    //     return;
    //   }
  
      try {
        await setIsLoadingCreate(true);
        setError(null);
        setErrorEmail(null)
        setErrorCompany(null)
        setErrorPhoneNumber(null)
        setErrorPassword(null)
        setErrorGeneral(null)

        var errorMsg = "";
        errorMsg = CreateAccountValid.checkCreateAccount(CreateAccountData, errorMsg);

        if(errorhelperText !== null){
          errorMsg += errorhelperText
        }

        if(errorMsg !== ""){
          setError(errorMsg)
          if(errorMsg.includes("email")){
            setErrorEmail(true)
          }
          if(errorMsg.includes("company")){
            setErrorCompany(true)
          }
          if(errorMsg.includes("phone number")){
            setErrorPhoneNumber(true)
          }
          if(errorMsg.includes("enter password")){
            setErrorPassword(true)
          }
          setIsLoadingCreate(false);
        }
        else if(errorhelperText !== null){
          setErrorConfirmPassword(errorhelperText);
          setIsLoadingCreate(false);
        }else{
          axios.post(`${process.env.REACT_APP_BASE_URL}/api/Account/create`, CreateAccountData).then((response)=>{
                  if (response.status !== 200){
                    if(response.data["Email"] === "Email already exists"){
                      setError("Email already exists. \n 電子郵件已註冊 \n");
                      setErrorEmail(true)
                    }else{
                      setError("Apply for Account failed. \n 申請帳戶失敗 \n");
                      setErrorGeneral(true)
                    }
                    setIsLoadingCreate(false);
                  }else{
                    handleClickOpenSuccess();
                    handleClose();
                    setIsLoadingCreate(false);
                  }
              }).catch((ex: any)=>{
                  if(ex.response.data["Email"]){
                    if(ex.response.data["Email"][0] === "Email already exists"){
                      setError("Email already exists. \n 電子郵件已註冊 \n");
                      setErrorEmail(true)
                    }else{
                      setError("Apply for Account failed. \n 申請帳戶失敗 \n");
                      setErrorGeneral(true)
                    }
                  }else{
                    setError("Apply for Account failed. \n 申請帳戶失敗 \n");
                    setErrorGeneral(true)
                  }
                  setIsLoadingCreate(false);
              })
          
        }
      } catch (ex: any) {
        setError(
          ex.data?.message || "Apply for Account failed. \n 申請帳戶失敗 \n"
        );
        setErrorGeneral(true)
        setIsLoadingCreate(false);
      }
    };


    const theme = createTheme({
        palette: {
            primary: {
                main: '#2e7d32',
              },
        },
      });

    useEffect(() => {
      const checkRefreshToken = async () => {
        try {
          const rt = localStorage.getItem("refreshToken");
          if (rt) {
            await setIsLoading(true);
          }
        } catch (ex) {
          console.error(ex);
        } finally {
          setIsLoading(false);
        }
      };
  
      checkRefreshToken();
    }, [navigate]);
  
    const globalState = useContext(GlobalStateContext);

    const handleLoginOnclick = async () => {
    //   if (!email || !password) {
    //     setError("Please enter both email and password");
    //     return;
    //   }
  
      try {
        await setIsLoading(true);
        setError(null);

        axios.post(`${process.env.REACT_APP_BASE_URL}/api/Account/login`, {Email: email, Password: password}).then((response)=>{
            if (response.status !== 200){
                setError("Login failed. Please check your credentials. \n 登入失敗 \n");
                setIsLoading(false);
            }else{
                localStorage.setItem("refreshToken", response.data.refreshToken)
                localStorage.setItem("accessToken", response.data.accessToken)
                localStorage.setItem("expireAt", response.data.expireAt)
                globalState?.setAccessToken(response.data.accessToken);
                setIsLoading(false);
                navigate("/loading");
            }
        }).catch(()=>{
            setError("Login failed. Please check your credentials. \n 登入失敗 \n");
            setIsLoading(false);
        })
      } catch (ex: any) {
        setError(
          ex.data?.message || "Login failed. Please check your credentials. \n 登入失敗 \n"
        );
        setIsLoading(false);
      }
    };
  
     const [open, setOpen] = useState(false);
     const [openForgotPassword, setOpenForgotPassword] = useState(false);

    useEffect(()=>{
        if(localStorage.accessToken){
          if(localStorage.accessToken && globalState?.accessToken !== ""){
            api.get(`/Account/userInfo`).then((response)=>{
                    if (response.status !== 200){
                    }else{
                        window.location.href='/form/list'
                    }
                    }).catch(()=>{
                    })
          }
        }else{
          api.get("/OIDC/getUserInfo",{withCredentials: true,}).then((response)=>{
                    if (response.status !== 200){
                    }else{
                        window.location.href='/form/list'
                    }
                    }).catch(()=>{
                })
        }
    },[globalState])


    const handleClickOpen = () => {
      setOpen(true);
    };

    const handleClose = () => {
      setOpen(false);
    };

    const [openSuccess, setOpenSuccess] = useState(false);
    const [openForgotPasswordEmailSuccess, setOpenForgotPasswordEmailSuccess] = useState(false);

    const handleClickOpenSuccess = () => {
      setOpenSuccess(true);
    };

    const handleCloseSuccess = () => {
      setOpenSuccess(false);
      window.location.reload()
    };

    useEffect(()=>{
      if (confirmPassword !== CreateAccountData.password){
        setErrorHelperText("Password reentered is not equal to the password in password field \n 密碼欄位中的密碼不相同 \n")
      }else{
        setErrorHelperText(null);
      }
    }
      ,[confirmPassword, CreateAccountData.password])

    return (
      <Box
        sx={{
          height: "100vh",
          width: "100vw",
          position: "fixed",
          top: 0,
          left: 0,
          background: theme.palette.background.default,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          overflow: "auto",
        }}
      >
        <Grid
          container
          spacing={0}
          direction={{ xs: "column", md: "column", lg: "row" }}
          sx={{
            maxWidth: { xs: "100%", sm: "450px", md: "600px", lg: "1200px" },
            width: "100%",
            margin: "0 auto",
            borderRadius: { xs: 0, lg: 2 },
            overflow: "hidden",
            backgroundColor: theme.palette.background.paper,
            minHeight: { xs: "100vh", lg: "70vh" },
            boxShadow: { lg: theme.shadows[4] },
          }}
        >
          {/* Title Section */}
          <Grid
            item
            xs={12}
            lg={6}
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.light} 100%)`,
              color: theme.palette.primary.contrastText,
              padding: { xs: 3, sm: 4, md: 5, lg: 6 },
              minHeight: { xs: "auto", lg: "500px" },
              position: "relative",
              overflow: "hidden",
              "&::before": {
                content: '""',
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background:
                  "radial-gradient(circle at 50% 50%, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0) 70%)",
                animation: "pulse 4s ease-in-out infinite",
                "@keyframes pulse": {
                  "0%": { transform: "scale(1)" },
                  "50%": { transform: "scale(1.2)" },
                  "100%": { transform: "scale(1)" },
                },
              },
            }}
          >
            <Fade in={true} timeout={1000}>
              <Box sx={{ position: "relative", zIndex: 1 }}>
                <Typography
                  variant="h4"
                  sx={{
                    fontSize: { xs: "1.5rem", sm: "2rem" },
                    fontWeight: 700,
                    letterSpacing: { xs: 1, sm: 2 },
                    textAlign: "center",
                    textShadow: "2px 2px 4px rgba(0,0,0,0.2)",
                  }}
                >
                  Castco E-forms <br></br> 佳力高網上表格
                </Typography>
                <Typography
                  variant="subtitle1"
                  sx={{
                    fontSize: { xs: "0.9rem", sm: "1rem" },
                    mt: { xs: 1, sm: 2 },
                    fontWeight: 300,
                    opacity: 0.9,
                    textAlign: "center",
                    textShadow: "1px 1px 2px rgba(0,0,0,0.1)",
                  }}
                >
                </Typography>
              </Box>
            </Fade>
          </Grid>
  
          {/* Login Form Section */}
          <Grid
            item
            xs={12}
            lg={6}
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              padding: { xs: 3, sm: 4, md: 5, lg: 6 },
              backgroundColor: theme.palette.background.paper,
            }}
          >
            <Box
              sx={{
                width: "100%",
                maxWidth: { xs: "100%", sm: 400 },
                borderRadius: 2,
                padding: { xs: 3, sm: 4 },
              }}
            >
              <Typography
                variant="h5"
                sx={{
                  fontSize: { xs: "1.25rem", sm: "1.5rem" },
                  fontWeight: 600,
                  color: theme.palette.primary.main,
                  textAlign: "center",
                  mb: { xs: 2, sm: 3 },
                }}
              >
                Sign In
              </Typography>
              <form noValidate>
              <TextField
                autoComplete="email"
                label="Email"
                type="email"
                value={email}
                InputLabelProps={{ shrink: true }}  
                onChange={(e) => setEmail(e.target.value)}
                onKeyUp={EnterKeyOnClick}
                fullWidth
                variant="outlined"
                error={!!error}
                disabled={isLoading}
                sx={{
                  mb: { xs: 2, sm: 3 },
                  "& .MuiOutlinedInput-root": {
                    borderRadius: { xs: "8px", sm: "12px" },
                    transition: "all 0.3s ease",
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      borderColor: theme.palette.primary.main,
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      borderColor: theme.palette.primary.main,
                      borderWidth: 2,
                    },
                  },
                  "& .MuiInputLabel-root": {
                    lineHeight: '1rem',
                    //color: theme.palette.primary.main,
                    "&.Mui-focused": { color: theme.palette.primary.main },
                  },
                  "& input": {
                    fontSize: { xs: "0.9rem", sm: "1rem" },
                    padding: { xs: "10px 12px", sm: "12px 14px" },
                  },
                }}
              />
  
              <TextField
                autoComplete="current-password"
                label="Password"
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                onKeyUp={EnterKeyOnClick}
                fullWidth
                variant="outlined"
                error={!!error}
                disabled={isLoading}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
                InputLabelProps={{ shrink: true }}  
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => setShowPassword(!showPassword)}
                        edge="end"
                        sx={{  color: isHovered ? theme.palette.primary.main : ""}}
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                sx={{
                  mb: { xs: 3, sm: 4 },
                  "& .MuiOutlinedInput-root": {
                    borderRadius: { xs: "8px", sm: "12px" },
                    transition: "all 0.3s ease",
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      borderColor: theme.palette.primary.main,
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      borderColor: theme.palette.primary.main,
                      borderWidth: 2,
                    },
                  },
                  "& .MuiInputLabel-root": {
                    lineHeight: '1rem',
                    //color: theme.palette.primary.main,
                    "&.Mui-focused": { color: theme.palette.primary.main },
                  },
                  "& input": {
                    fontSize: { xs: "0.9rem", sm: "1rem" },
                    padding: { xs: "10px 12px", sm: "12px 14px" },
                  },
                }}
              />
              <Button
                variant="contained"
                onClick={handleLoginOnclick}
                disabled={isLoading}
                fullWidth
                startIcon={
                  isLoading ? (
                    <CircularProgress size={20} color="inherit" />
                  ) : (
                    <LoginIcon />
                  )
                }
                sx={{
                  padding: { xs: "10px", sm: "12px" },
                  borderRadius: { xs: "20px", sm: "25px" },
                  background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.light} 100%)`,
                  textTransform: "none",
                  fontWeight: 500,
                  fontSize: { xs: "1rem", sm: "1.1rem" },
                  transition: "all 0.3s ease",
                  "&:hover": {
                    background: `linear-gradient(135deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 100%)`,
                    transform: "translateY(-2px)",
                    boxShadow: theme.shadows[4],
                  },
                  "&:focus": {
                    outline: `2px solid ${alpha(
                      theme.palette.primary.main,
                      0.5
                    )}`,
                    outlineOffset: "2px",
                  },
                  "&:disabled": {
                    background: theme.palette.action.disabledBackground,
                    color: theme.palette.action.disabled,
                  },
                }}
              >
                {isLoading ? "Signing in..." : "Sign In"}
              </Button>
              </form>
              <div className="mt-3"></div>
              <Button
                variant="contained"
                onClick={handleClickOpen}
                fullWidth
                sx={{
                  padding: { xs: "10px", sm: "12px" },
                  borderRadius: { xs: "20px", sm: "25px" },
                  background: `linear-gradient(135deg, ${theme.palette.success.main} 0%, ${theme.palette.success.light} 100%)`,
                  textTransform: "none",
                  fontWeight: 500,
                  fontSize: { xs: "1rem", sm: "1.1rem" },
                  transition: "all 0.3s ease",
                  "&:hover": {
                    background: `linear-gradient(135deg, ${theme.palette.success.dark} 0%, ${theme.palette.success.main} 100%)`,
                    transform: "translateY(-2px)",
                    boxShadow: theme.shadows[4],
                  },
                  "&:focus": {
                    outline: `2px solid ${alpha(
                      theme.palette.success.main,
                      0.5
                    )}`,
                    outlineOffset: "2px",
                  },
                }}
              >
                Apply for Account
              </Button>
              <div className="mt-3"></div>
              <Button
                variant="contained"
                onClick={()=>{window.location.href=process.env.REACT_APP_HR_PRO_SIGN_IN_URL!;}}
                fullWidth
                sx={{
                  padding: { xs: "10px", sm: "12px" },
                  borderRadius: { xs: "20px", sm: "25px" },
                  background: `linear-gradient(135deg, ${theme.palette.error.main} 0%, ${theme.palette.error.light} 100%)`,
                  textTransform: "none",
                  fontWeight: 500,
                  fontSize: { xs: "1rem", sm: "1.1rem" },
                  transition: "all 0.3s ease",
                  "&:hover": {
                    background: `linear-gradient(135deg, ${theme.palette.error.dark} 0%, ${theme.palette.error.main} 100%)`,
                    transform: "translateY(-2px)",
                    boxShadow: theme.shadows[4],
                  },
                  "&:focus": {
                    outline: `2px solid ${alpha(
                      theme.palette.error.main,
                      0.5
                    )}`,
                    outlineOffset: "2px",
                  },
                }}
              >
                Sign in With Castco Account
              </Button>
              <div className="mt-3"></div>
              <Button
                variant="contained"
                onClick={()=>{setOpenForgotPassword(true)}}
                fullWidth
                sx={{
                  padding: { xs: "10px", sm: "12px" },
                  borderRadius: { xs: "20px", sm: "25px" },
                  background: `linear-gradient(135deg, ${theme.palette.error.main} 0%, ${theme.palette.error.light} 100%)`,
                  textTransform: "none",
                  fontWeight: 500,
                  fontSize: { xs: "1rem", sm: "1.1rem" },
                  transition: "all 0.3s ease",
                  "&:hover": {
                    background: `linear-gradient(135deg, ${theme.palette.error.dark} 0%, ${theme.palette.error.main} 100%)`,
                    transform: "translateY(-2px)",
                    boxShadow: theme.shadows[4],
                  },
                  "&:focus": {
                    outline: `2px solid ${alpha(
                      theme.palette.error.main,
                      0.5
                    )}`,
                    outlineOffset: "2px",
                  },
                }}
              >
                Forgot Password
              </Button>
            </Box>
          </Grid>
        </Grid>
  
        <Snackbar
          open={!!error}
          autoHideDuration={6000}
          onClose={() => setError(null)}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        >
          <Alert
            onClose={() => setError(null)}
            severity="error"
            variant="filled"
            sx={{ width: "100%" }}
          >
            <Typography variant="body2">
              {error && error!.split('\n').map((line, index) => (
                <span key={index}>
                  {line}
                  <br />
                </span>
              ))}
            </Typography>
          </Alert>
        </Snackbar>
      
      

      <Dialog
        open={openForgotPasswordEmailSuccess}
      >

              <Box
              sx={{
                width: "100%",
                maxWidth: { xs: "100%", sm: 700 },
                borderRadius: 2,
                padding: { xs: 3, sm: 4 },
              }}>
              <Typography
                  variant="h4"
                  sx={{
                    fontSize: { xs: "1.5rem", sm: "2rem" },
                    fontWeight: 700,
                    color: theme.palette.primary.main,
                    letterSpacing: { xs: 1, sm: 2 },
                    textAlign: "center",
                    textShadow: "2px 2px 4px rgba(0,0,0,0.2)",
                  }}
                >
                  Success
                </Typography>
                <Typography
                  variant="subtitle1"
                  sx={{
                    fontSize: { xs: "0.9rem", sm: "1rem" },
                    mt: { xs: 1, sm: 2 },
                    fontWeight: 300,
                    opacity: 0.9,
                    textAlign: "center",
                    textShadow: "1px 1px 2px rgba(0,0,0,0.1)",
                  }}
                >
                忘記密碼電子郵件已發送。<br></br><br></br>

                Forgot Password Email is sent.
                </Typography>
                <div className="mb-3"></div>
                <Button
                variant="contained"
                onClick={()=>setOpenForgotPasswordEmailSuccess(false)}
                fullWidth
                sx={{
                  padding: { xs: "10px", sm: "12px" },
                  borderRadius: { xs: "20px", sm: "25px" },
                  background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.light} 100%)`,
                  textTransform: "none",
                  fontWeight: 500,
                  fontSize: { xs: "1rem", sm: "1.1rem" },
                  transition: "all 0.3s ease",
                  "&:hover": {
                    background: `linear-gradient(135deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 100%)`,
                    transform: "translateY(-2px)",
                    boxShadow: theme.shadows[4],
                  },
                  "&:focus": {
                    outline: `2px solid ${alpha(
                      theme.palette.primary.main,
                      0.5
                    )}`,
                    outlineOffset: "2px",
                  },
                }}
              >
                Close
              </Button>
              </Box>

      </Dialog>


        <Dialog
        open={openSuccess}
      >

              <Box
              sx={{
                width: "100%",
                maxWidth: { xs: "100%", sm: 700 },
                borderRadius: 2,
                padding: { xs: 3, sm: 4 },
              }}>
              <Typography
                  variant="h4"
                  sx={{
                    fontSize: { xs: "1.5rem", sm: "2rem" },
                    fontWeight: 700,
                    color: theme.palette.primary.main,
                    letterSpacing: { xs: 1, sm: 2 },
                    textAlign: "center",
                    textShadow: "2px 2px 4px rgba(0,0,0,0.2)",
                  }}
                >
                  Success
                </Typography>
                <Typography
                  variant="subtitle1"
                  sx={{
                    fontSize: { xs: "0.9rem", sm: "1rem" },
                    mt: { xs: 1, sm: 2 },
                    fontWeight: 300,
                    opacity: 0.9,
                    textAlign: "center",
                    textShadow: "1px 1px 2px rgba(0,0,0,0.1)",
                  }}
                >
                您的帳號申請已經提交。我們將會審核您的申請，可能需時數天。
                如有問題，請致電2597 8273查詢。<br></br><br></br>

                Yours account application has been submitted.
                We will review your application. The review process may take several days.
                If you have any question, please contact us at 2597 8273.
                </Typography>
                <div className="mb-3"></div>
                <Button
                variant="contained"
                onClick={handleCloseSuccess}
                fullWidth
                sx={{
                  padding: { xs: "10px", sm: "12px" },
                  borderRadius: { xs: "20px", sm: "25px" },
                  background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.light} 100%)`,
                  textTransform: "none",
                  fontWeight: 500,
                  fontSize: { xs: "1rem", sm: "1.1rem" },
                  transition: "all 0.3s ease",
                  "&:hover": {
                    background: `linear-gradient(135deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 100%)`,
                    transform: "translateY(-2px)",
                    boxShadow: theme.shadows[4],
                  },
                  "&:focus": {
                    outline: `2px solid ${alpha(
                      theme.palette.primary.main,
                      0.5
                    )}`,
                    outlineOffset: "2px",
                  },
                }}
              >
                Close
              </Button>
              </Box>

      </Dialog>

        <Dialog
        open={open}
        onClose={handleClose}
      >
        <Box
              sx={{
                width: "100%",
                maxWidth: { xs: "100%", sm: 400 },
                borderRadius: 2,
                padding: { xs: 3, sm: 4 },
              }}
            >
              <Typography
                variant="h5"
                sx={{
                  fontSize: { xs: "1.25rem", sm: "1.5rem" },
                  fontWeight: 600,
                  color: theme.palette.primary.main,
                  textAlign: "center",
                  mb: { xs: 2, sm: 3 },
                }}
              >
                Apply for Account
              </Typography>
        <form noValidate>
              <TextField
                autoComplete="off"
                label="Company"
                type="text"
                value={CreateAccountData.company}
                InputLabelProps={{ shrink: true }}  
                onChange={(e) => {setCreateAccount({...CreateAccountData, company: e.target.value}); setErrorCompany(null)}}
                onKeyUp={EnterKeyOnClickCreate}
                fullWidth
                variant="outlined"
                error={!!errorGeneral || !!errorCompany}
                disabled={isLoadingCreate}
                sx={{
                  mb: { xs: 2, sm: 3 },
                  "& .MuiOutlinedInput-root": {
                    borderRadius: { xs: "8px", sm: "12px" },
                    transition: "all 0.3s ease",
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      borderColor: theme.palette.primary.main,
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      borderColor: theme.palette.primary.main,
                      borderWidth: 2,
                    },
                  },
                  "& .MuiInputLabel-root": {
                    lineHeight: '1rem',
                    //color: theme.palette.primary.main,
                    "&.Mui-focused": { color: theme.palette.primary.main },
                  },
                  "& input": {
                    fontSize: { xs: "0.9rem", sm: "1rem" },
                    padding: { xs: "10px 12px", sm: "12px 14px" },
                  },
                }}
              />
              <TextField
                autoComplete="off"
                label="Name"
                type="text"
                value={CreateAccountData.name}
                InputLabelProps={{ shrink: true }}  
                onChange={(e) => setCreateAccount({...CreateAccountData, name: e.target.value})}
                onKeyUp={EnterKeyOnClickCreate}
                fullWidth
                variant="outlined"
                error={!!errorGeneral}
                disabled={isLoadingCreate}
                sx={{
                  mb: { xs: 2, sm: 3 },
                  "& .MuiOutlinedInput-root": {
                    borderRadius: { xs: "8px", sm: "12px" },
                    transition: "all 0.3s ease",
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      borderColor: theme.palette.primary.main,
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      borderColor: theme.palette.primary.main,
                      borderWidth: 2,
                    },
                  },
                  "& .MuiInputLabel-root": {
                    lineHeight: '1rem',
                    //color: theme.palette.primary.main,
                    "&.Mui-focused": { color: theme.palette.primary.main },
                  },
                  "& input": {
                    fontSize: { xs: "0.9rem", sm: "1rem" },
                    padding: { xs: "10px 12px", sm: "12px 14px" },
                  },
                }}
              />
              <TextField
                autoComplete="tel"
                label="Phone Number"
                type="tel"
                value={CreateAccountData.phoneNumber}
                InputLabelProps={{ shrink: true }}  
                onChange={(e) => {setCreateAccount({...CreateAccountData, phoneNumber: e.target.value}); setErrorPhoneNumber(null)}}
                onKeyUp={EnterKeyOnClickCreate}
                fullWidth
                variant="outlined"
                error={!!errorGeneral || !!errorPhoneNumber}
                disabled={isLoadingCreate}
                sx={{
                  mb: { xs: 2, sm: 3 },
                  "& .MuiOutlinedInput-root": {
                    borderRadius: { xs: "8px", sm: "12px" },
                    transition: "all 0.3s ease",
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      borderColor: theme.palette.primary.main,
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      borderColor: theme.palette.primary.main,
                      borderWidth: 2,
                    },
                  },
                  "& .MuiInputLabel-root": {
                    lineHeight: '1rem',
                    //color: theme.palette.primary.main,
                    "&.Mui-focused": { color: theme.palette.primary.main },
                  },
                  "& input": {
                    fontSize: { xs: "0.9rem", sm: "1rem" },
                    padding: { xs: "10px 12px", sm: "12px 14px" },
                  },
                }}
              />
              <TextField
                autoComplete="email"
                label="Email"
                type="email"
                value={CreateAccountData.email}
                InputLabelProps={{ shrink: true }}  
                onChange={(e) => {setCreateAccount({...CreateAccountData, email: e.target.value}); setErrorEmail(null)}}
                onKeyUp={EnterKeyOnClickCreate}
                fullWidth
                variant="outlined"
                error={!!errorGeneral || !!errorEmail}
                disabled={isLoadingCreate}
                sx={{
                  mb: { xs: 2, sm: 3 },
                  "& .MuiOutlinedInput-root": {
                    borderRadius: { xs: "8px", sm: "12px" },
                    transition: "all 0.3s ease",
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      borderColor: theme.palette.primary.main,
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      borderColor: theme.palette.primary.main,
                      borderWidth: 2,
                    },
                  },
                  "& .MuiInputLabel-root": {
                    lineHeight: '1rem',
                    //color: theme.palette.primary.main,
                    "&.Mui-focused": { color: theme.palette.primary.main },
                  },
                  "& input": {
                    fontSize: { xs: "0.9rem", sm: "1rem" },
                    padding: { xs: "10px 12px", sm: "12px 14px" },
                  },
                }}
              />
  
              <TextField
                autoComplete="new-password"
                label="Password"
                type={showPasswordCreate ? "text" : "password"}
                value={CreateAccountData.password}
                onChange={(e) => setCreateAccount({...CreateAccountData, password: e.target.value})}
                onKeyUp={EnterKeyOnClickCreate}
                onMouseEnter={() => setIsHoveredPasswordApply(true)}
                onMouseLeave={() => setIsHoveredPasswordApply(false)}
                fullWidth
                variant="outlined"
                error={!!errorGeneral || !!errorPassword}
                disabled={isLoadingCreate}
                InputLabelProps={{ shrink: true }}  
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => setShowPasswordCreate(!showPasswordCreate)}
                        edge="end"
                        sx={{  color: isHoveredPasswordApply ? theme.palette.primary.main : ""}}
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                sx={{
                  mb: { xs: 3, sm: 4 },
                  "& .MuiOutlinedInput-root": {
                    borderRadius: { xs: "8px", sm: "12px" },
                    transition: "all 0.3s ease",
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      borderColor: theme.palette.primary.main,
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      borderColor: theme.palette.primary.main,
                      borderWidth: 2,
                    },
                  },
                  "& .MuiInputLabel-root": {
                    lineHeight: '1rem',
                    //color: theme.palette.primary.main,
                    "&.Mui-focused": { color: theme.palette.primary.main },
                  },
                  "& input": {
                    fontSize: { xs: "0.9rem", sm: "1rem" },
                    padding: { xs: "10px 12px", sm: "12px 14px" },
                  },
                }}
              />
              <TextField
                autoComplete="new-password"
                label="Confirm Password"
                type={showPasswordDoubleCreate ? "text" : "password"}
                onChange={(e) => {
                  setConfirmPassword(e.target.value)
                }}
                onKeyUp={EnterKeyOnClickCreate}
                onMouseEnter={() => setIsHoveredConfirmPassword(true)}
                onMouseLeave={() => setIsHoveredConfirmPassword(false)}
                fullWidth
                variant="outlined"
                error={!!errorhelperText || !!errorConfirmPassword || !!errorGeneral}
                disabled={isLoadingCreate}
                InputLabelProps={{ shrink: true }}  
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => setShowPasswordDoubleCreate(!showPasswordDoubleCreate)}
                        edge="end"
                        sx={{  color: isHoveredConfirmPassword ? theme.palette.primary.main : ""}}
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                sx={{
                  mb: { xs: 3, sm: 4 },
                  "& .MuiOutlinedInput-root": {
                    borderRadius: { xs: "8px", sm: "12px" },
                    transition: "all 0.3s ease",
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      borderColor: theme.palette.primary.main,
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      borderColor: theme.palette.primary.main,
                      borderWidth: 2,
                    },
                  },
                  "& .MuiInputLabel-root": {
                    lineHeight: '1rem',
                    //color: theme.palette.primary.main,
                    "&.Mui-focused": { color: theme.palette.primary.main },
                  },
                  "& input": {
                    fontSize: { xs: "0.9rem", sm: "1rem" },
                    padding: { xs: "10px 12px", sm: "12px 14px" },
                  },
                }}
              />
              <Button
                variant="contained"
                onClick={handleCreate}
                disabled={isLoadingCreate}
                fullWidth
                sx={{
                  padding: { xs: "10px", sm: "12px" },
                  borderRadius: { xs: "20px", sm: "25px" },
                  background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.light} 100%)`,
                  textTransform: "none",
                  fontWeight: 500,
                  fontSize: { xs: "1rem", sm: "1.1rem" },
                  transition: "all 0.3s ease",
                  "&:hover": {
                    background: `linear-gradient(135deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 100%)`,
                    transform: "translateY(-2px)",
                    boxShadow: theme.shadows[4],
                  },
                  "&:focus": {
                    outline: `2px solid ${alpha(
                      theme.palette.primary.main,
                      0.5
                    )}`,
                    outlineOffset: "2px",
                  },
                  "&:disabled": {
                    background: theme.palette.action.disabledBackground,
                    color: theme.palette.action.disabled,
                  },
                }}
              >
                {isLoadingCreate ? <CircularProgress/> : "Apply"}
              </Button>
              </form>
              </Box>
              <Snackbar
                open={!!error}
                autoHideDuration={6000}
                onClose={() => setError(null)}
                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
              >
                <Alert
                  onClose={() => setError(null)}
                  severity="error"
                  variant="filled"
                  sx={{ width: "100%" }}
                >
                  <Typography variant="body2">
                    {error && error.split('\n').map((line, index) => (
                      <span key={index}>
                        {line}
                        <br />
                      </span>
                    ))}
                  </Typography>
                </Alert>
              </Snackbar>
              <Snackbar
                open={!!errorConfirmPassword}
                autoHideDuration={6000}
                onClose={() => setErrorConfirmPassword(null)}
                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
              >
                <Alert
                  onClose={() => setErrorConfirmPassword(null)}
                  severity="error"
                  variant="filled"
                  sx={{ width: "100%" }}
                >
                  <Typography variant="body2">
                    {errorConfirmPassword && errorConfirmPassword.split('\n').map((line, index) => (
                      <span key={index}>
                        {line}
                        <br />
                      </span>
                    ))}
                  </Typography>
                </Alert>
              </Snackbar>
      </Dialog>
      {(isLoadingForgotPassword || isLoading || isLoadingCreate) && <div style={{position:"fixed", left:"0", top:"0", width:"100%", height:"100%", zIndex:"100", background:"rgba(0, 0, 0, 0.4)"}}></div>}
      
        <Dialog
        open={openForgotPassword}
        onClose={()=>setOpenForgotPassword(false)}
      >
        <Box
              sx={{
                width: "100%",
                maxWidth: { xs: "100%", sm: 400 },
                borderRadius: 2,
                padding: { xs: 3, sm: 4 },
              }}
            >
              <Typography
                variant="h5"
                sx={{
                  fontSize: { xs: "1.25rem", sm: "1.5rem" },
                  fontWeight: 600,
                  color: theme.palette.primary.main,
                  textAlign: "center",
                  mb: { xs: 2, sm: 3 },
                }}
              >
                Forgot Password
              </Typography>
        <form noValidate>
              
              <TextField
                autoComplete="email"
                label="Email"
                type="email"
                value={forgotPasswordEmail}
                InputLabelProps={{ shrink: true }}  
                onChange={(e) => {setForgotPasswordEmail(e.target.value); setErrorForgotPasswordEmail(null)}}
                onKeyUp={EnterKeyOnClickSendForgotPasswordEmail}
                fullWidth
                variant="outlined"
                error={!!errorForgotPasswordEmail}
                disabled={isLoadingForgotPassword}
                sx={{
                  mb: { xs: 2, sm: 3 },
                  "& .MuiOutlinedInput-root": {
                    borderRadius: { xs: "8px", sm: "12px" },
                    transition: "all 0.3s ease",
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      borderColor: theme.palette.primary.main,
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      borderColor: theme.palette.primary.main,
                      borderWidth: 2,
                    },
                  },
                  "& .MuiInputLabel-root": {
                    lineHeight: '1rem',
                    //color: theme.palette.primary.main,
                    "&.Mui-focused": { color: theme.palette.primary.main },
                  },
                  "& input": {
                    fontSize: { xs: "0.9rem", sm: "1rem" },
                    padding: { xs: "10px 12px", sm: "12px 14px" },
                  },
                }}
              />
  
              <Button
                variant="contained"
                onClick={handleSendForgotPasswordEmail}
                disabled={isLoadingForgotPassword}
                fullWidth
                sx={{
                  padding: { xs: "10px", sm: "12px" },
                  borderRadius: { xs: "20px", sm: "25px" },
                  background: `linear-gradient(135deg, ${theme.palette.error.main} 0%, ${theme.palette.error.light} 100%)`,
                  textTransform: "none",
                  fontWeight: 500,
                  fontSize: { xs: "1rem", sm: "1.1rem" },
                  transition: "all 0.3s ease",
                  "&:hover": {
                    background: `linear-gradient(135deg, ${theme.palette.error.dark} 0%, ${theme.palette.error.main} 100%)`,
                    transform: "translateY(-2px)",
                    boxShadow: theme.shadows[4],
                  },
                  "&:focus": {
                    outline: `2px solid ${alpha(
                      theme.palette.error.main,
                      0.5
                    )}`,
                    outlineOffset: "2px",
                  },
                  "&:disabled": {
                    background: theme.palette.action.disabledBackground,
                    color: theme.palette.action.disabled,
                  },
                }}
              >
                {isLoadingForgotPassword ? <CircularProgress/> : "Send Email"}
              </Button>
              </form>
              </Box>
              <Snackbar
                open={!!errorForgotPassword}
                autoHideDuration={6000}
                onClose={() => setErrorForgotPassword(null)}
                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
              >
                <Alert
                  onClose={() => setErrorForgotPassword(null)}
                  severity="error"
                  variant="filled"
                  sx={{ width: "100%" }}
                >
                  <Typography variant="body2">
                    {errorForgotPassword && errorForgotPassword.split('\n').map((line, index) => (
                      <span key={index}>
                        {line}
                        <br />
                      </span>
                    ))}
                  </Typography>
                </Alert>
              </Snackbar>
      </Dialog>

      </Box>






      

    );
  };
  
  export default LoginPage;
  